import { registerQuery } from 'data-fetching-client';
export const FETCH_NEVER_LOG_LIST = registerQuery({
  fieldName: 'neverLogList',
  args: ['apiClient'],
  fetcher: ({
    apiClient
  }) => apiClient.get('/engagements-emails/v1/blocklist/with-limits')
});